import { SanitySlug, SanityIcon, SanityObjectWithout } from './types';

export type MenuLink = {
    title: string;
    icon: SanityObjectWithout<SanityIcon, 'slug'>;
    description?: string;
    page: { slug: SanitySlug };
    section: { _id: string } | null;
};

export type MenuItem =
    | {
          text: string;
          children: MenuItem[];
      }
    | MenuLink;

export type RenderedMenuLink = MenuLink & {
    link: string;
};

export type RenderedMenuItem =
    | {
          text: string;
          children: RenderedMenuItem[];
      }
    | RenderedMenuLink;

export const setHref = (item: MenuLink): string => {
    const section = item.section ? `/${item.section._id}` : '';
    const page = `/${item.page.slug.current}`;
    const href = `${page}${section}`;
    return href;
};

export const isMenuLink = (item: MenuItem): item is MenuLink => {
    if (!Array.isArray(item) && 'title' in item) {
        return true;
    }
    return false;
};

export const renderMenuItemHrefs = (items: MenuItem[]): RenderedMenuItem[] =>
    items.map(item => {
        if (isMenuLink(item)) {
            return { ...item, link: setHref(item) };
        } else {
            return { ...item, children: renderMenuItemHrefs(item.children) };
        }
    });
